import { Model } from '@models/model';
import { Paginated } from '@models/paginated';

export class PartnerReportCampaigns extends Model {
  typeCampaign: string;
  visitors: number;
  registered: number;
  newCustomers: number;
  newPurchases: number;
  totalPurchases: number;
  newProfit: string;
  totalProfit: string;
}

export class ListPartnerReportCampaigns extends Paginated {
  data: Array<PartnerReportCampaigns>;
}

export class PartnerReferrals extends Model {
  idUser: number;
  login: string;
  companyName: string;
  createType: string;
  createDate: string;
  purchasesCount: number;
  totalPurchasesCount: number;
}

export class ListPartnerReferrals extends Paginated {
  data: Array<PartnerReferrals>;
}

export class PartnerReportReferrals extends Model {
  idCart: number;
  createDate: string;
  idUser: number;
  totalAmount: string;
  status: string;
  partnerProfit: string;
}

export class ListPartnerReportReferrals extends Paginated {
  data: Array<PartnerReportReferrals>;
}
